import { FC } from 'react';
import { useStyles } from '../../utils';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { checkoutFormStyles, StyleKey } from './base-checkout-form.styles';

export interface CheckoutFormProps {
	DetailsHeader?: () => JSX.Element;
	OrderSummary?: () => JSX.Element;
	FormHeading?: () => JSX.Element;
	FormContent?: () => JSX.Element;
	sx?: Partial<Record<StyleKey, SxProps<Theme>>>;
}

export const BaseCheckoutForm: FC<CheckoutFormProps> = (props) => {
	const { DetailsHeader, OrderSummary, FormHeading, FormContent, sx } = props;

	const styles = useStyles(checkoutFormStyles, sx);

	return (
		<Box sx={styles.root}>
			<Box sx={styles.detailsLeft}>
				<Box sx={styles.detailsHeader}>
					{DetailsHeader?.()}
				</Box>

				<Box position="relative" zIndex={1}>
					<svg
						style={{
							height: '1px',
							width: '100%',
							position: 'absolute',
							bottom: 0,
							left: 0,
							strokeWidth: '1px',
						}}
					>
						<line x1="0" y1="0" x2="100%" y2="0" stroke="#FFFFFF1A" strokeDasharray="6 6" />
					</svg>
				</Box>

				<Box sx={styles.detailsSummary}>
					{OrderSummary?.()}
				</Box>
			</Box>

			<Box sx={styles.formRight}>
				{FormHeading?.()}

				<Box sx={styles.formContent}>
					{FormContent?.()}
				</Box>
			</Box>
		</Box>
	);
};
